<template>
  <div style="margin-top: 200px">
    <center>
      {{ title }}
    </center>
  </div>
</template>

<script>
import {postAction} from '@/api/manage';
import {Toast} from 'vant';

export default {
  components: {[Toast.name]: Toast},
  data() {
    return {
      code: '',
      departCode: '',
      uOpenId: '',
      title: '系统正在授权中……',
      url: '/web/api/auth/getLoginUrl'
    };
  },
  mounted() {
    this.urls = this.$route.query.urls;
    this.departCode = this.$route.query.departCode;
    this.toQs();
  },
  methods: {
    toQs() {
      localStorage.setItem('urls', this.urls);
      postAction(this.url, {departCode: this.departCode}).then(res => {
        window.location.href = res.result.data;
      }).finally(() => {
      })
    }
  }
};
</script>

<style lang="less">
</style>
